module.exports = __webpack_public_path__ + "img/view_2.86390e46.jpg";